module.exports = __webpack_public_path__ + "img/secondary_icon50x21.56d9616f.png";